export default __webpack_public_path__ + "static/media/glass.36bee624.jpg";